import { SchemaTypes } from '@allesauto/graphql';
import React, { FC } from 'react';

import Carousel, { CarouselProps } from '../carousel';
import VehicleImage, { VehicleImageProps } from '../vehicleImage';

export interface GalleryProps {
  items:
    | SchemaTypes.VehicleImage[]
    | SchemaTypes.ProductImage[]
    | GalleryImage[];
  selectedSlide?: number;
  carouselClassNames?: CarouselProps['classNames'];
  pictureClassNames?: string;
  imageAspectRatio?: VehicleImageProps['aspectRatio'];
}

export interface GalleryImage {
  component: string;
  label: string;
  link: string;
  image: {
    alt: string;
    filename: string;
    id: string;
    is_external_url: boolean;
    title: string;
  };
}

const Gallery: FC<React.PropsWithChildren<GalleryProps>> = ({
  items,
  selectedSlide,
  carouselClassNames,
  pictureClassNames,
  imageAspectRatio = '16_BY_10',
}) => {
  const DISPLAYED_ITEMS = 1;

  const className = {
    carouselContainerClass: 'col-end-25 col-start-1 self-center',
    pictureContainerClass: pictureClassNames,
  };

  return (
    <div className={className.carouselContainerClass}>
      <Carousel
        isInfinite={false}
        itemsTable={DISPLAYED_ITEMS}
        itemsMobile={DISPLAYED_ITEMS}
        itemsLDesktop={DISPLAYED_ITEMS}
        itemsXLDesktop={DISPLAYED_ITEMS}
        itemsToScrollXLDesktop={DISPLAYED_ITEMS}
        itemsToScrollLDesktop={DISPLAYED_ITEMS}
        itemsToScrollMobile={DISPLAYED_ITEMS}
        itemsToScrollTablet={DISPLAYED_ITEMS}
        carouselItems={items}
        classNames={carouselClassNames}
        hasThumbnailList={true}
        selectedSlide={selectedSlide}
        hasTransition={false}
        imageAspectRatio={imageAspectRatio}
      >
        {items?.map((item, index: number) => (
          <div key={index} className={className.pictureContainerClass}>
            <VehicleImage
              aspectRatio={imageAspectRatio}
              filename={
                (item as SchemaTypes.VehicleImage).externalUrlLarge ||
                (item as SchemaTypes.ProductImage).url
              }
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Gallery;
